const EXTENSION_SCRIPT_PATTERN = /^(chrome|moz|safari|webkit)-extension:\/\//i;
const ANONYMOUS_FRAME_PATTERN = /^(<anonymous>|\[native code\])$/i;
const PARENT_ELEMENT_NOISE_PATTERN =
  /Cannot read propert(?:y|ies) of undefined \(reading ['"]parentElement['"]\)/i;

function getExceptionFrames(event) {
  const values = event?.exception?.values;
  if (!Array.isArray(values) || !values.length) return [];
  const frames = values[0]?.stacktrace?.frames;
  return Array.isArray(frames) ? frames : [];
}

function getExceptionMessage(event) {
  const values = event?.exception?.values;
  if (!Array.isArray(values) || !values.length) return '';
  const first = values[0] || {};
  return `${first.type || ''} ${first.value || ''}`.trim();
}

function isNonAppScriptFrame(frame) {
  const path = String(frame?.filename || frame?.abs_path || '').trim();
  if (!path) return true;
  if (ANONYMOUS_FRAME_PATTERN.test(path)) return true;
  if (EXTENSION_SCRIPT_PATTERN.test(path)) return true;
  return false;
}

/**
 * Drop third-party / extension DOM noise that lands as unhandledrejection with
 * no actionable app frames (e.g. LLP-FE-F parentElement on /dashboard).
 * Keep events that include at least one real application or vendor frame.
 */
export function shouldDropNonActionableClientNoise(event) {
  const message = getExceptionMessage(event);
  if (!PARENT_ELEMENT_NOISE_PATTERN.test(message)) return false;

  const frames = getExceptionFrames(event);
  if (!frames.length) return true;

  return frames.every(isNonAppScriptFrame);
}

export const SENTRY_EXTENSION_DENY_URLS = [
  /extensions\//i,
  /^chrome(?:-extension)?:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-extension:\/\//i,
  /^webkit-masked-url:\/\//i,
];
